// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ws4iN","delete":"styles_delete__1gmJz","update":"styles_update__X56x1","add":"styles_add__49RVZ"};